import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/jxcount',
    meta: { title: '储运绩效' },
    component: Layout,
    redirect: '/jxcount',
    children: [
      {
        path: '',
        meta: { title: '储运绩效', activeMenu: '/jxcount' },
        component: () => import('@/views/oilTankCost/JxCount.vue')
      },
      {
        path: 'detail',
        meta: { title: '储运绩效详情', activeMenu: '/jxcount' },
        component: () => import('@/views/oilTankCost/JxCountDetail.vue')
      }
    ]
  },
  {
    path: '/invoiceManage',
    meta: { title: '发票管理' },
    component: Layout,
    redirect: '/invoiceManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '发票管理', activeMenu: '/invoiceManage' },
        component: () => import('@/views/invoiceManage/Index.vue')
      },
      {
        path: 'detail',
        meta: { title: '发票详情', activeMenu: '/invoiceManage' },
        component: () => import('@/views/invoiceManage/InvoiceManageDetail.vue')
      }

    ]
  }

]
